import React from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { StatCard } from '../../components/ui/StatCard';
import { DataTable } from '../../components/ui/DataTable';
import { User, Mail, Phone, Calendar, Briefcase, CheckCircle2, TrendingUp, Users, FileText, Award } from 'lucide-react';
// Mock Data
const distributorProfile = {
  id: 'DST-001',
  name: 'Andi Pratama',
  role: 'Senior Campaign Manager',
  email: 'andi.pratama@kemenlhk.go.id',
  phone: '0812-3456-7890',
  department: 'Direktorat Pengelolaan Sampah',
  joinDate: '15 Jan 2023',
  stats: {
    campaignsCreated: 24,
    activeCampaigns: 3,
    avgCompletionRate: 88,
    avgReceiverScore: 92,
    totalReceiversManaged: 1540
  }
};
const campaignHistory = [{
  id: 'CMP-001',
  title: 'Kampanye HPSN 2025',
  date: '10 Feb 2025',
  receivers: 514,
  completion: 95,
  status: 'active'
}, {
  id: 'CMP-002',
  title: 'Sosialisasi Bank Sampah',
  date: '01 Feb 2025',
  receivers: 120,
  completion: 78,
  status: 'completed'
}, {
  id: 'CMP-003',
  title: 'Edukasi Pemilahan Sampah',
  date: '15 Jan 2025',
  receivers: 514,
  completion: 92,
  status: 'completed'
}, {
  id: 'CMP-004',
  title: 'Program Kali Bersih',
  date: '01 Jan 2025',
  receivers: 200,
  completion: 85,
  status: 'completed'
}];
export function ProfilDistributorPage() {
  const columns = [{
    header: 'Nama Campaign',
    cell: (row: any) => <div data-id="element-2111">
          <div className="font-medium text-gray-900" data-id="element-2112">{row.title}</div>
          <div className="text-xs text-gray-500" data-id="element-2113">{row.date}</div>
        </div>
  }, {
    header: 'Penerima',
    cell: (row: any) => <div className="flex items-center gap-1 text-sm text-gray-600" data-id="element-2114">
          <Users className="h-4 w-4" data-id="element-2115" /> {row.receivers}
        </div>
  }, {
    header: 'Completion',
    cell: (row: any) => <div className="flex items-center gap-2" data-id="element-2116">
          <div className="w-24 bg-gray-100 rounded-full h-2" data-id="element-2117">
            <div className={`h-2 rounded-full ${row.completion >= 80 ? 'bg-green-500' : 'bg-yellow-500'}`} style={{
          width: `${row.completion}%`
        }} data-id="element-2118"></div>
          </div>
          <span className="text-xs font-medium" data-id="element-2119">{row.completion}%</span>
        </div>
  }, {
    header: 'Status',
    cell: (row: any) => <StatusBadge status={row.status === 'active' ? 'hijau' : 'neutral'} data-id="element-2120">
          {row.status === 'active' ? 'Aktif' : 'Selesai'}
        </StatusBadge>
  }];
  return <CommandCenterLayout title="Profil Distributor" subtitle="Dashboard kinerja dan histori distribusi konten Anda" data-id="element-2121">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2122">
        {/* Left Column: Profile Card */}
        <div className="space-y-6" data-id="element-2123">
          <Card data-id="element-2124">
            <CardContent className="p-6 text-center" data-id="element-2125">
              <div className="h-24 w-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 border-4 border-white shadow-sm" data-id="element-2126">
                <User className="h-12 w-12 text-blue-600" data-id="element-2127" />
              </div>
              <h2 className="text-xl font-bold text-gray-900" data-id="element-2128">
                {distributorProfile.name}
              </h2>
              <p className="text-sm text-gray-500 mb-4" data-id="element-2129">
                {distributorProfile.role}
              </p>

              <div className="flex justify-center gap-2 mb-6" data-id="element-2130">
                <StatusBadge status="hijau" data-id="element-2131">Active</StatusBadge>
                <StatusBadge status="neutral" data-id="element-2132">Admin Pusat</StatusBadge>
              </div>

              <div className="space-y-4 text-left border-t pt-4" data-id="element-2133">
                <div className="flex items-center gap-3 text-sm" data-id="element-2134">
                  <Briefcase className="h-4 w-4 text-gray-400" data-id="element-2135" />
                  <span className="text-gray-600" data-id="element-2136">
                    {distributorProfile.department}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-sm" data-id="element-2137">
                  <Mail className="h-4 w-4 text-gray-400" data-id="element-2138" />
                  <span className="text-gray-600" data-id="element-2139">
                    {distributorProfile.email}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-sm" data-id="element-2140">
                  <Phone className="h-4 w-4 text-gray-400" data-id="element-2141" />
                  <span className="text-gray-600" data-id="element-2142">
                    {distributorProfile.phone}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-sm" data-id="element-2143">
                  <Calendar className="h-4 w-4 text-gray-400" data-id="element-2144" />
                  <span className="text-gray-600" data-id="element-2145">
                    Bergabung: {distributorProfile.joinDate}
                  </span>
                </div>
              </div>

              <div className="mt-6" data-id="element-2146">
                <Button variant="outline" className="w-full" data-id="element-2147">
                  Edit Profil
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Right Column: Stats & History */}
        <div className="lg:col-span-2 space-y-6" data-id="element-2148">
          {/* Stats Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2149">
            <StatCard title="Total Campaign" value={distributorProfile.stats.campaignsCreated.toString()} icon={FileText} description="Campaign dibuat" data-id="element-2150" />
            <StatCard title="Rata-rata Completion" value={`${distributorProfile.stats.avgCompletionRate}%`} icon={CheckCircle2} trend={{
            value: '+2.5%',
            direction: 'up'
          }} description="Kinerja penerima" data-id="element-2151" />
            <StatCard title="Skor Binaan" value={distributorProfile.stats.avgReceiverScore.toString()} icon={Award} description="Rata-rata skor daerah" data-id="element-2152" />
            <StatCard title="Total Penerima" value={distributorProfile.stats.totalReceiversManaged.toLocaleString()} icon={Users} description="Jangkauan distribusi" data-id="element-2153" />
          </div>

          {/* Campaign History */}
          <Card data-id="element-2154">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-2155">
              <CardTitle data-id="element-2156">Histori Campaign</CardTitle>
              <Button variant="ghost" size="sm" data-id="element-2157">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-2158">
              <DataTable data={campaignHistory} columns={columns} keyExtractor={item => item.id} data-id="element-2159" />
            </CardContent>
          </Card>
        </div>
      </div>
    </CommandCenterLayout>;
}